import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/account')({
  // Component is lazy loaded from account.lazy.tsx
});
